export default "__VITE_ASSET__a1396602__"